import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { Constants } from '../constants';
import { parse, format, AsYouType } from 'libphonenumber-js';
declare var $: any;
declare var body: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  nao = new Nanobar();
  platformFeeData: any;
  updateId: any;
  platform_charges = '';
  disableClick: any;
  sec_name = 'Amazon';
  accessKey = '';
  secretKey = '';
  regionName = '';
  sid = '';
  token = '';
  number = '';
  smsData: any;
  smsDataSuccess: any;
  smsDataAmazon: any;
  smsDataTwillio: any;
  error_count = 0;
  smsDefault: any;
  smsDefaultSuccess: any;

  notificationMail = '';
  notificationPhone = '';
  notificationData: any;
  notificationBtn = true;
  notificationSubmit: any;
  emailChk: any;
  disabledClick: any;
  deleteCachy: any;
  dropOffOrderID: any;
  generatedCode: any;
  sum: any;
  num: any;
  bankFee: number;

  constructor(private dataService: DataService) { }
  getPlatformFeeFunction() {
    this.nao.go(30);
    this.dataService.getPlatformCharges(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        this.platformFeeData = data;
        this.platform_charges = this.platformFeeData[0].platform_fee;
        this.bankFee = this.platformFeeData[0].bank_fee_percentage;
      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  updateFeePop(id) {
    this.platform_charges = this.platformFeeData[0].platform_fee;
    this.updateId = id;
    $('#updatePop').modal('show');
  }

  openBankFeePopup() {
    $('#updateBankFeePop').modal('show');
  }
  updateBankFee() {
    this.disableClick = true;
    if (!this.bankFee || this.bankFee > 5) {
      toastr.error('Please add platform charges');
      this.disableClick = false;
      return;
    }
    this.nao.go(30);
    this.dataService.updatePlatformCharges(window.localStorage.getItem('token'), this.updateId, this.platform_charges, this.bankFee).subscribe(
      (data) => {
        this.nao.go(100);
        $('#updateBankFeePop').modal('hide');
        this.getPlatformFeeFunction();
        this.disableClick = false;
      },
      (error) => {
        this.disableClick = false;
        this.nao.go(100);
      }
    );
  }

  updatePlatformFeeFunction() {
    this.disableClick = true;
    if (this.platform_charges === '') {
      toastr.error('Please add platform charges');
      this.disableClick = false;
      return;
    }
    this.nao.go(30);
    this.dataService.updatePlatformCharges(window.localStorage.getItem('token'), this.updateId, this.platform_charges,this.bankFee).subscribe(
      (data) => {
        this.nao.go(100);
        $('#updatePop').modal('hide');
        this.getPlatformFeeFunction();
        this.disableClick = false;
      },
      (error) => {
        this.disableClick = false;
        this.nao.go(100);
      }
    );
  }
  preventMinus(e) {
    console.log('e value', e);
    var inputKeyCode = e.keyCode ? e.keyCode : e.which;
    if (inputKeyCode != null) {
      if (inputKeyCode === 45) e.preventDefault();
    }
  }
  checkNum() {
    this.bankFee > 5 ? this.bankFee = 5 : this.bankFee = this.bankFee
  }

  changeSmsSeeting(name) {
    this.sec_name = name;
  }
  getSmsSettingFunction() {
    this.dataService.getSmsSetting(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.smsData = data;
        this.smsDataAmazon = this.smsData.Amazon_Dictionary;
        this.smsDataTwillio = this.smsData.Twillio_Dictionary;
        this.accessKey = this.smsDataAmazon.token_key_id;
        this.secretKey = this.smsDataAmazon.secret_key_sns;
        this.regionName = this.smsDataAmazon.number_region;
        this.token = this.smsDataTwillio.token_key_id;
        this.sid = this.smsDataTwillio.secret_key_sns;
        this.number = this.smsDataTwillio.number_region;
      },
      (error) => {
      }
    );
  }
  updateAmazone() {
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');

    if (this.accessKey === '') {
      $('#accessKey label').css('color', '#a10a0d');
      $('#accessKey input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.secretKey === '') {
      $('#secretKey label').css('color', '#a10a0d');
      $('#secretKey input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.regionName === '') {
      $('#regionName label').css('color', '#a10a0d');
      $('#regionName input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.error_count > 0) {
      return;
    }
    this.nao.go(30);
    this.dataService.editSmsSetting(window.localStorage.getItem('token'), this.accessKey, this.secretKey, this.regionName, this.sec_name).subscribe(
      (data) => {
        this.nao.go(100);
        this.smsDataSuccess = data;
        this.smsDataSuccess = this.smsDataSuccess.success;
        if (this.smsDataSuccess = true) {
          toastr.success('Update sms setting');
        }
        if (this.smsDataSuccess = false) {
          toastr.success('Something went wrong');
        }
        this.getSmsSettingFunction();
      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  updateTwllio() {
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');

    if (this.token === '') {
      $('#token label').css('color', '#a10a0d');
      $('#token input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.sid === '') {
      $('#sid label').css('color', '#a10a0d');
      $('#sid input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.number === '') {
      $('#number label').css('color', '#a10a0d');
      $('#number input').css('border-color', '#a10a0d');
      this.error_count++;
    }
    if (this.error_count > 0) {
      return;
    }
    this.nao.go(30);
    this.dataService.editSmsSetting(window.localStorage.getItem('token'), this.token, this.sid, this.number, this.sec_name).subscribe(
      (data) => {
        this.nao.go(100);
        this.smsDataSuccess = data;
        this.smsDataSuccess = this.smsDataSuccess.success;
        if (this.smsDataSuccess = true) {
          toastr.success('Update sms setting');
        }
        if (this.smsDataSuccess = false) {
          toastr.success('Something went wrong');
        }
        this.getSmsSettingFunction();
      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  getSmsSettingValue() {
    // $('#AmazonFalse').prop('checked', false);
    // $('#AmazonTrue').prop('checked', true);
    // $('#TwillioFalse').prop('checked', false);
    // $('#TwillioTrue').prop('checked', true);
    this.dataService.getSmsSettingValue(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.smsDefault = data;
        if (this.smsDefault.Amazon === true) {
          $('#AmazonTrue').prop('checked', true);
        } else {
          $('#TwillioTrue').prop('checked', true);
        }

      },
      (error) => {
      }
    );
  }
  updateSmsSettingValue(value, id) {
    $('#AmazonFalse').prop('checked', false);
    $('#AmazonTrue').prop('checked', false);
    $('#TwillioFalse').prop('checked', false);
    $('#TwillioTrue').prop('checked', false);

    this.dataService.updateSmsSettingValue(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.smsDefaultSuccess = data;
        this.smsDefaultSuccess = this.smsDefaultSuccess.success;
        if (this.smsDefaultSuccess = true) {
          toastr.success('Update sms setting');
        }
        if (this.smsDefaultSuccess = false) {
          toastr.success('Something went wrong');
        }
        this.getSmsSettingValue();

      },
      (error) => {
      }
    );
  }


  getNotificationMail() {
    this.dataService.getnotificationsettings(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.notificationBtn = true;
        this.notificationData = data;
        this.notificationMail = this.notificationData.email;
        this.notificationPhone = this.notificationData.phone_number;
      },
      (error) => {
      }
    );
  }
  chkUpdateNotificationFun() {
    if (this.notificationMail !== '' || this.notificationPhone !== '') {
      this.notificationBtn = false;
    } else {
      this.notificationBtn = true;
    }
  }
  UpdateNotificationFun() {
    // this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // this.emailChk = /[a-zA-Z0-9_.+-,;]+@(?:(?:[a-zA-Z0-9-]+\.,;)?[a-zA-Z]+\.,;)?(gmail)\.com/;
    // if (this.notificationMail !== '') {
    //   if (!this.emailChk.test(this.notificationMail)) {
    //     toastr.error('Please enter a valid email');
    //     return;
    //   }
    // }
    this.nao.go(30);
    this.dataService.updatenotification(window.localStorage.getItem('token'), this.notificationMail, this.notificationPhone).subscribe(
      (data) => {
        this.notificationSubmit = data;
        this.nao.go(100);
        if (this.notificationSubmit.success === true) {
          this.getNotificationMail();
          toastr.success('Notification update sucessfuly');
        } else {
          toastr.success('Something went wrong');
        }

      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  clearCache() {
    $('#cacheDeleteAlert').modal('show');
  }
  cachyDeleteConform() {
    this.nao.go(30);
    this.dataService.clearCachy(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.deleteCachy = data;
        this.nao.go(100);
        $('#cacheDeleteAlert').modal('hide');
        if (this.deleteCachy.success === true) {
          toastr.success('Cachy delete sucessfuly');
        } else {
          toastr.error('Something went wrong');
        }

      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  ngOnInit() {
    this.getNotificationMail();
    this.getPlatformFeeFunction();
    this.getSmsSettingFunction();
    this.getSmsSettingValue();
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#settings').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

  forceDropOffCode() {
    if (this.dropOffOrderID == null) {
      toastr.error('Please enter Order ID');
    } else {
      this.dropOffOrderID = this.dropOffOrderID.toUpperCase();
      this.sum = 0;
      for (var i = 0; i < this.dropOffOrderID.length; i++) {
        this.sum += this.dropOffOrderID.charCodeAt(i);
      }
      this.sum = this.sum * 1234;
      let finalString = new Array;
      while (this.sum > 0) {
        this.num = Math.trunc(this.sum % 10);
        this.sum = Math.trunc(this.sum / 10);
        switch (this.num) {
          case 0: {
            finalString.push("a");
            break;
          }
          case 1: {
            finalString.push("b");
            break;
          }
          case 2: {
            finalString.push("c");
            break;
          }
          case 3: {
            finalString.push("d");
            break;
          }
          case 4: {
            finalString.push("e");
            break;
          }
          case 5: {
            finalString.push("f");
            break;
          }
          case 6: {
            finalString.push("g");
            break;
          }
          case 7: {
            finalString.push("h");
            break;
          }
          case 8: {
            finalString.push("i");
            break;
          }
          case 9: {
            finalString.push("j");
            break;
          }
        }
        this.generatedCode = finalString.map(x => x).join("");
      }
      $('#dropOffCodePop').modal('show');
    }
  }

  forcePickUpCode() {
    if (this.dropOffOrderID == null) {
      toastr.error('Please enter Order ID');
    } else {
      this.dropOffOrderID = this.dropOffOrderID.toUpperCase();
      this.sum = 0;
      for (var i = 0; i < this.dropOffOrderID.length; i++) {
        this.sum += this.dropOffOrderID.charCodeAt(i);
      }
      this.sum = this.sum * 4321;
      let finalString = new Array;
      while (this.sum > 0) {
        this.num = Math.trunc(this.sum % 10);
        this.sum = Math.trunc(this.sum / 10);
        switch (this.num) {
          case 0: {
            finalString.push("q");
            break;
          }
          case 1: {
            finalString.push("3");
            break;
          }
          case 2: {
            finalString.push("r");
            break;
          }
          case 3: {
            finalString.push("4");
            break;
          }
          case 4: {
            finalString.push("s");
            break;
          }
          case 5: {
            finalString.push("5");
            break;
          }
          case 6: {
            finalString.push("t");
            break;
          }
          case 7: {
            finalString.push("6");
            break;
          }
          case 8: {
            finalString.push("u");
            break;
          }
          case 9: {
            finalString.push("7");
            break;
          }
        }
        this.generatedCode = finalString.map(x => x).join("");
      }
      $('#pickUpCodePop').modal('show');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts